var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenland(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0342C0 7.19768 7.1635 0.0341797 16 0.0341797C24.8365 0.0341797 32 7.19768 32 16.0342C31.3044 16.0342 16 18.1211 16 18.1211L0 16.0342Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0342C32 24.8707 24.8365 32.0342 16 32.0342C7.1635 32.0342 0 24.8707 0 16.0342",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1306 23.686C15.3568 23.686 18.7828 20.26 18.7828 16.0338C18.7828 11.8076 15.3568 8.38159 11.1306 8.38159C6.9044 8.38159 3.47839 11.8076 3.47839 16.0338C3.47839 20.26 6.9044 23.686 11.1306 23.686Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47839 16.0338C3.47839 11.8077 6.90439 8.38159 11.1306 8.38159C15.3568 8.38159 18.7828 11.8077 18.7828 16.0338",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenland);
export default __webpack_public_path__ + "static/media/greenland.7d4cf860.svg";
export { ForwardRef as ReactComponent };